import { Autocomplete, TextField } from "@mui/material";
import { FieldError } from "react-hook-form";

export const optionsTypeCode = [
	{ Code: "E", Name: "Edger" },
	{ Code: "U", Name: "Universal" },
];

type Props = {
	label: string;
	value: string | null;
	onChange?: Function;
	fieldError?: FieldError | undefined;
	disabled?: boolean;
};

export const RollTypeSelector = ({
	label,
	value,
	onChange = () => {},
	fieldError,
	disabled = false,
}: Props) => {
	const selectedType =
		optionsTypeCode.find((code) => code.Code === value) || null;

	return (
		<Autocomplete
			id="clear-on-escape"
			clearOnEscape
			options={
				value === "B"
					? optionsTypeCode.filter((code) => code.Code !== "T")
					: optionsTypeCode
			}
			getOptionLabel={(option) => option.Name}
			renderInput={(params) => (
				<TextField
					{...params}
					label={label}
					variant="outlined"
					fullWidth
					error={!!fieldError}
					helperText={fieldError?.message}
					size="small"
				/>
			)}
			value={selectedType}
			onChange={(event, newValue) => {
				onChange(newValue?.Code ?? null);
			}}
			disabled={disabled}
		/>
	);
};
